import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["id"];

function _async(f) {
  return function () {
    for (var args = [], i = 0; i < arguments.length; i++) {
      args[i] = arguments[i];
    }

    try {
      return Promise.resolve(f.apply(this, args));
    } catch (e) {
      return Promise.reject(e);
    }
  };
}

import React, { useEffect, useMemo, useContext } from 'react';
import { hideModal, removeModal, showModal, useStore } from './store';
import { callbacks } from './callbacks';
import { components } from './components';
import { getModalId } from './id';

var _open = _async(function (modal, args) {
  var id = getModalId(modal);

  if (typeof modal !== 'string') {
    register(id, modal);
  }

  showModal(id, args);

  if (!callbacks[id]) {
    var resolve;
    var promise = new Promise(function (r) {
      resolve = r;
    });
    callbacks[id] = {
      resolve: resolve,
      promise: promise
    };
  }

  return callbacks[id].promise;
});

var DemodalIdContext = /*#__PURE__*/React.createContext('');

function _close(modal) {
  var id = getModalId(modal);
  hideModal(id);
}

function _remove(id) {
  removeModal(id);
  delete callbacks[id];
}

export var useModal = function useModal() {
  var modal = arguments.length <= 0 ? undefined : arguments[0];
  var args = arguments.length <= 1 ? undefined : arguments[1];
  var modals = useStore();
  var contextModalId = useContext(DemodalIdContext);
  var id = modal ? getModalId(modal) : contextModalId;
  useEffect(function () {
    if (modal && typeof modal !== 'string') {
      register(id, modal);
    }
  }, [id, modal, args]);
  var modalInfo = modals[id];
  return useMemo(function () {
    return {
      id: id,
      args: modalInfo == null ? void 0 : modalInfo.args,
      isOpen: !!(modalInfo != null && modalInfo.isOpen),
      open: function open(args) {
        return _open(id, args);
      },
      close: function close() {
        return _close(id);
      },
      remove: function remove() {
        return _remove(id);
      },
      resolve: function resolve(args) {
        var _callbacks$id;

        (_callbacks$id = callbacks[id]) == null ? void 0 : _callbacks$id.resolve(args);
        delete callbacks[id];
      }
    };
  }, [id, modalInfo]);
};

function create(Comp) {
  return function (_ref) {
    var id = _ref.id,
        props = _objectWithoutPropertiesLoose(_ref, _excluded);

    var _useModal = useModal(id),
        args = _useModal.args;

    var modals = useStore();
    var modal = modals[id];

    if (!modal) {
      return null;
    }

    return /*#__PURE__*/React.createElement(DemodalIdContext.Provider, {
      value: id
    }, /*#__PURE__*/React.createElement(Comp, _extends({}, props, args)));
  };
}

function register(id, comp) {
  if (!components[id]) {
    components[id] = comp;
  }
}

function unregister(id) {
  delete components[id];
}

function Container(_ref2) {
  var containerId = _ref2.containerId;
  var modals = useStore();
  var renderedModals = Object.keys(modals).filter(function (id) {
    var _modals$id, _modals$id$args;

    return ((_modals$id = modals[id]) == null ? void 0 : (_modals$id$args = _modals$id.args) == null ? void 0 : _modals$id$args.containerId) === containerId && components[id];
  }).map(function (id) {
    var _modals$id2;

    return {
      id: id,
      args: ((_modals$id2 = modals[id]) == null ? void 0 : _modals$id2.args) || {},
      Component: components[id]
    };
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, renderedModals.map(function (_ref3) {
    var id = _ref3.id,
        Component = _ref3.Component,
        args = _ref3.args;
    return /*#__PURE__*/React.createElement(Component, _extends({
      key: id,
      id: id
    }, args));
  }));
}

function Register(_ref4) {
  var id = _ref4.id,
      component = _ref4.component;
  useEffect(function () {
    register(id, component);
    return function () {
      unregister(id);
    };
  }, [id, component]);
  return null;
}

export var Demodal = {
  Container: Container,
  Register: Register,
  create: create,
  open: _open,
  close: _close,
  register: register,
  unregister: unregister
};